import { gql } from '@apollo/client';
import TENANT_SUPPLIER from 'api/fragments/TENANT_SUPPLIER';
const RETRIEVE_TENANT_SUPPLIER = gql `
  ${TENANT_SUPPLIER}
  mutation RetrieveTenantSupplier($supplierId: ID!) {
    retrieveSupplier(supplierId: $supplierId) {
      supplier {
        ...TenantSupplierFragment
      }
    }
  }
`;
export default RETRIEVE_TENANT_SUPPLIER;
